import { GenIcon } from '../helpers/IconBase.es.js';

const PaymentOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.75 5.5C4.05964 5.5 3.5 6.05964 3.5 6.75V8.25H20.5V6.75C20.5 6.05964 19.9404 5.5 19.25 5.5H4.75ZM3.5 11.25V9.75H20.5V11.25H3.5ZM3.5 12.75V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H19.25C19.9404 18.5 20.5 17.9404 20.5 17.25V12.75H3.5ZM2 6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7688 4 22 5.23122 22 6.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75ZM5.25 16C5.25 15.5858 5.58579 15.25 6 15.25H10C10.4142 15.25 10.75 15.5858 10.75 16C10.75 16.4142 10.4142 16.75 10 16.75H6C5.58579 16.75 5.25 16.4142 5.25 16ZM16 15.25C15.5858 15.25 15.25 15.5858 15.25 16C15.25 16.4142 15.5858 16.75 16 16.75H17C17.4142 16.75 17.75 16.4142 17.75 16C17.75 15.5858 17.4142 15.25 17 15.25H16Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { PaymentOutlined };
